import React, { ComponentProps } from 'react';
import { IconDeprecated, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { CardListItemSubComponentProps, wrapCardListItemSubComponent, WrappedCardListItemSubComponent } from '../CardListItem/cardListItemSubComponent';
import styles from './CardListItemIconButton.module.css';
export type CardListItemIconButtonProps = ComponentProps<'button'> & CardListItemSubComponentProps<{
  iconName: string;
  iconType?: IconType;
}>;
export const CardListItemIconButton: WrappedCardListItemSubComponent<CardListItemIconButtonProps> = wrapCardListItemSubComponent(props => {
  const {
    iconName,
    iconType,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true,
    filter: ['cardListItemInfo']
  });
  return <button type="button" {...remainingProps} className={classes(className, styles.iconWrapper)}>
        <IconDeprecated name={iconName} type={iconType}></IconDeprecated>
      </button>;
});